var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStorySocialLaugh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FBE56D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F69E33"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4A2313"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6B2F10"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FD5473"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C21C2F"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "url(#a)",
  rx: 20
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#283250",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.5 15.5q2.5 0 4 1t2 2.5q-5 0-7.5.5M34 17.5a11.7 11.7 0 0 0-3.5.5 10 10 0 0 0-3 1.5q5.5 2 7 3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M10.5 24.52c3.068-1.523 6.648-1.523 12.273-1.015q5.626.507 9.717 3.047c.18 3.033-2.046 5.586-3.069 6.602-1.022 1.016-3.58 3.047-7.67 3.047-4.092 0-6.648-2.031-8.694-4.063q-2.046-2.03-2.557-7.618"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M20.943 31.12q5.625.507 8 2.5-3.158 2.7-7.25 2.7c-4.09 0-6.647-2.03-8.693-4.062q2.318-1.646 7.943-1.138"
}))));
export default SvgFacebookMobileStorySocialLaugh;